export class DiagnosticId {
  readonly #value: string;

  private constructor(value: string) {
    this.#value = value;
  }

  static of(value: DiagnosticId | string): DiagnosticId {
    if (value instanceof DiagnosticId) {
      return value;
    }
    return new DiagnosticId(value);
  }

  get value(): string {
    return this.#value;
  }
}
